<template>
  <AwlTable :heading="tableHeadings" :rows="tableRows" striped class="costi-ga-table">
    <template #column-key-importo="{ value }">
      {{ value | money }}
    </template>

    <template #column-key-delta="{ value }">
      {{ value }}%
    </template>
    <template #column-key-vat="{ value }">
      {{ value }}%
    </template>
    <template #column-key-ritenuta="{ value }">
      {{ value }}%
    </template>

    <template #column-key-dilazione="{ value }">
      {{ value * 30 }}
    </template>

    <template v-if="editEnabled" #actions-content="{ row }">
      <ActionEdit class="mr-0 mr-md-2" :to="{ name: 'operative-company.data-analysis.ga.edit', params: { costId: row.id } }" />
      <ActionDelete @click="remove(row.id)" />
    </template>
  </AwlTable>
</template>

<script>

import formatMoneyFilter from '@/filters/formatMoney.js';

import AwlTable from '@/libs/Table/components/AwlTable.vue';
import ActionDelete from '@/views/components/Actions/ActionDelete.vue';
import ActionEdit from '@/views/components/Actions/ActionEdit.vue';

export default {
  components: {
    AwlTable,
    ActionDelete,
    ActionEdit,
  },
  filters: {
    money: formatMoneyFilter,
  },
  props: {
    costi: {
      type: Array,
      default: () => [],
    },
    editEnabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tableHeadings () {
      return [
        { key: 'name', label: 'Nome' },
        { key: 'importo', label: 'Importo annuo' },

        { key: 'begin', label: 'Primo costo' },
        { key: 'end', label: 'Ultimo costo' },
        { key: 'frequenzaName', label: 'Frequenza' },
        { key: 'dilazione', label: 'GG Dilazione' },

        { key: 'delta', label: 'Delta' },
        { key: 'vat', label: 'Iva' },
        { key: 'ritenuta', label: 'Ritenuta fiscale' },
      ];
    },
    tableRows () {
      return (this.costi || []).map(r => {
        return r;
      });
    },
  },
  methods: {
    remove (id) {
      if (!this.editEnabled) {
        return;
      }

      this.$emit('delete', id);
    },
  },
};

</script>
